import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function DoorRightIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16.571 4.00007C18.6339 4.00007 21.4513 5.20466 22.8305 6.67664L29.8984 14.2161C30.8187 15.1971 31.2484 17.0334 30.8528 18.2992L28.5398 25.7007C28.1453 26.965 26.6963 28 25.3208 28H3.5001C2.11825 28 0.999999 26.9254 0.999999 25.5999V4L16.571 4.00007ZM27.0833 14.7997L20.9728 8.28222C20.0645 7.31416 17.9259 6.39982 16.571 6.39982H3.5001V14.7997H27.0833ZM3.5001 19.5999H8.49994V17.1998H3.5001V19.5999Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
